import ApplicationReports from "./ApplicationReports";

const AllApplications = () => {
  return(
    <ApplicationReports status="" title="District Total Applications Report" heading="Total Applications"></ApplicationReports>
  )
};

export default AllApplications;
